import React, { useEffect, useState } from "react"; 
import { Swiper, SwiperSlide } from "swiper/react";
import { Link } from "react-router-dom";
import "swiper/css"
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/autoplay"; // optional, just for clarity
import { Navigation, Pagination, Autoplay } from "swiper/modules"; 
  const TrustedPartner = ({city}) => {  
    const [listings, setListings] = useState([]);
     const [loading, setLoading] = useState(true);
  const API =  process.env.REACT_APP_API_URL || "https://nvrealestate.websiteseoonline.com";

     useEffect(() => {
       fetch(`${API}/api/developerlisthome.ashx`, {
         method: "POST",
         headers: {
           "Content-Type": "application/json"
         },
         body: JSON.stringify({ city })
       }) // 🔁 replace URL
         .then((res) => res.json())
         .then((res) => {
           console.log("API Response:", res);
   
           // ✅ Handle different API formats safely
           const result = Array.isArray(res) ? res : res.data;
   
           setListings(result || []);
           setLoading(false);
         })
         .catch((err) => {
           console.error("API Error:", err);
           listings([]);
           setLoading(false);
         });
     },  [city]);
  
    if (loading) return <p>Loading developers...</p>;
  
  return (
    <div className="wrap-categories-sw wow fadeInUp" data-wow-delay=".2s">
      <Swiper
        spaceBetween={30}
        slidesPerView={6}
        modules={[Navigation,Autoplay]} 
        //navigation               // ✅ arrows
        pagination={{ clickable: true }}  // ✅ dots
         autoplay={{
          delay: 3000, // 3 seconds
          disableOnInteraction: false, // continue autoplay after user interaction
        }}
        breakpoints={{
          320: { slidesPerView: 2, spaceBetween: 15 },
          640: { slidesPerView: 2, spaceBetween: 15 },
          768: { slidesPerView: 5, spaceBetween: 30 },
          1024: { slidesPerView: 8, spaceBetween: 30 },
        }}
        className="tf-sw-categories"
      >
       {listings.map(item => (
       <SwiperSlide>
       <Link className="images-group" to={`/developers/${item.url}`}>
            <img src={item.ImagePath+'/w=421,sharpen=1'} alt={item.title}  className=" ls-is-cached lazyloaded developerlogo" />
                  
                  </Link>
  </SwiperSlide>
    ))}
        {/* Add other SwiperSlide components here */}
      </Swiper>
    </div>
  );
}

export default TrustedPartner;
